import React, {Fragment} from "react";
import { connect } from "react-redux";

// import LookWishlistPopup from "./lookWishlistPopup";
import LookMessageBoxPopup from "./lookMessageBoxPopup";
import SuccessNotification from "../../ui/successNotification";
import LoaderView from "../../ui/loaderView";
import LookQuestionPopup from "./lookQuestionPopup";
import LookStylePopup from "./lookStylePopup";
// import LookRemovePopup from "./lookRemovePopup";
import LookOverlayQuestions from "./lookOverlayQuestions";
import MobileRotateButton from "../../ui/mobileRotateButtonHorizontalNew";
import LookLoadingPopup from "./lookLoadingPopup";
import LookNotCompatiblePopup from "./lookNotCompatiblePopup";
import WithLoginPostMessage from "../hocs/withLoginPostMessage";
import LeadCapturePopup from "./leadCapturePopup/leadCapturePopup";
import SqftFeaturesPopupWrapper from "../../popups/sqftFeaturesPopup/sqftFeaturesPopupWrapper";
import ConfirmPopup from "../../popups/confirmPopup";

const LookPopups = () => {

  return (
    <Fragment>
      {/*<LookWishlistPopup/>*/}
      <LookQuestionPopup/>
      <LookStylePopup/>
      <LeadCapturePopup/>
      {/*<LookRemovePopup/>*/}
      <LookOverlayQuestions/>
      <LookMessageBoxPopup/>
      <LoaderView/>
      <SuccessNotification/>
      <MobileRotateButton/>
      <LookNotCompatiblePopup/>
      <ConfirmPopup/>
      <WithLoginPostMessage>
        {(loginPostMessage) => <LookLoadingPopup loginPostMessage={loginPostMessage}/>}
      </WithLoginPostMessage>
      <SqftFeaturesPopupWrapper/>
    </Fragment>
  )
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LookPopups)
